import { render, staticRenderFns } from "./BaseDocumentsModal.vue?vue&type=template&id=ab7a138a&"
import script from "./BaseDocumentsModal.vue?vue&type=script&lang=js&"
export * from "./BaseDocumentsModal.vue?vue&type=script&lang=js&"
import style0 from "./BaseDocumentsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports